import { Trans } from "react-i18next";

import util from "utils/utils";

export default function groupInvitedContent({ events, ownerGroup }) {
  return (
    <Trans
      i18nKey="notifications.groupInvited"
      values={{
        name: util.getEventNames(events),
        group: ownerGroup?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  );
}
